// extracted by mini-css-extract-plugin
export default {"wrapper":"Stores_wrapper__lCais","loadingwrapper":"Stores_loadingwrapper__rP8jQ"};